import SvgIcon from "@mui/material/SvgIcon";

export default function NotInListIcon() {
  return (
    <SvgIcon>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g fill="none">
              <circle cx="12" cy="12" r="12"/>
              <path d="M5.754 16a.736.736 0 0 1-.535-.214.714.714 0 0 1-.219-.532c0-.21.071-.39.214-.535a.714.714 0 0 1 .532-.219c.21 0 .39.071.535.214.146.143.219.32.219.532 0 .21-.071.39-.214.535a.714.714 0 0 1-.532.219zm0-3.25a.736.736 0 0 1-.535-.214.714.714 0 0 1-.219-.532c0-.21.071-.39.214-.535a.714.714 0 0 1 .532-.219c.21 0 .39.071.535.214.146.143.219.32.219.532 0 .21-.071.39-.214.535a.714.714 0 0 1-.532.219zm0-3.25a.736.736 0 0 1-.535-.214A.714.714 0 0 1 5 8.754c0-.21.071-.39.214-.535A.714.714 0 0 1 5.746 8c.21 0 .39.071.535.214.146.143.219.32.219.532 0 .21-.071.39-.214.535a.714.714 0 0 1-.532.219zM8 16v-1.5h11V16H8zm0-3.25v-1.5h11v1.5H8zM8 9.5V8h11v1.5H8z" fillRule="nonzero" fill="currentColor"/>
              <path fill="currentColor" fillRule="evenodd" d="m20.798 5 .794 1.092L3.793 19.024 3 17.932z"/>
          </g>
      </svg>
    </SvgIcon>
  )
}
